<template>
  <div id="notice-editor-confirmation-dialog">
    <v-dialog v-model="confirmationDialog" width="1000">
      <v-card>
        <v-card-title>登録確認</v-card-title>
        <v-card-text class="text-lg-body-1"
          >以下の配信お知らせ情報を登録しますか？</v-card-text
        >
        <v-textarea
          v-model="noticeInput"
          class="px-5 pb-5"
          outlined
          auto-grow
          no-resize
          readonly
        ></v-textarea>
        <v-card-actions class="px-5 pb-5">
          <v-btn color="primary" @click="confirmationDialog = false" width="100"
            >キャンセル</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="error" @click="editNotice()" width="100">登録</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { Component, Vue, PropSync, Prop, Emit } from "vue-property-decorator";

@Component
export default class NtcEdtConfirmationDialog extends Vue {
  /** ダイアログ表示フラグ */
  @PropSync("confirmationDialogFlag", { type: Boolean, default: false })
  confirmationDialog!: boolean;

  /** 配信お知らせ情報の編集内容 */
  @Prop({ type: String })
  noticeInput!: string;

  /**
   * 登録実行時の処理
   * ※処理は親コンポーネントの関数で行う。
   */
  @Emit("editNotice")
  editNotice(): void {
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/common.scss";
@import "@/scss/common.scss";
.v-text-field--outlined {
  ::v-deep fieldset {
    border-color: black;
  }
}
</style>
